import { Endpoints } from 'utils/endpoints';
import { variablesBffClient } from 'services/api';

class TopLevelObjectTypeRepositoryClass {
  public async getTopLevelObjectTypes() {
    return await variablesBffClient.get(Endpoints.getFlexDataTopLevelObjectTypes);
  }
}

export const TopLevelObjectTypeRepository = new TopLevelObjectTypeRepositoryClass();
